import { cva, type VariantProps } from "class-variance-authority";

/**
 * Zalando font variants mapped to local font files in /public/assets/fonts.
 */
export const zalandoFontCva = cva("font-heading", {
  variants: {
    variant: {
      extraLight: "font-extralight",
      extraLightItalic: "font-extralight italic",
      light: "font-light",
      lightItalic: "font-light italic",
      regular: "font-normal",
      italic: "font-normal italic",
      medium: "font-medium",
      mediumItalic: "font-medium italic",
      semiBold: "font-semibold",
      semiBoldItalic: "font-semibold italic",
      bold: "font-bold",
      boldItalic: "font-bold italic",
      extraBold: "font-extrabold",
      extraBoldItalic: "font-extrabold italic",
      black: "font-black",
      blackItalic: "font-black italic",
    },
  },
  defaultVariants: {
    variant: "regular",
  },
});

export type ZalandoFontVariantProps = VariantProps<typeof zalandoFontCva>;

/**
 * Semantic typography presets.
 */
export const typographyCva = cva("", {
  variants: {
    preset: {
      display:
        "font-heading font-extrabold not-italic text-6xl mobile-landscape:text-7xl tablet:text-8xl leading-[1] tracking-display text-center",
      h1: "font-heading font-bold not-italic text-5xl",
      h2: "font-heading font-bold not-italic text-4xl",
      h3: "font-heading font-semibold not-italic text-2xl",
      bodyLg: "font-sans font-normal not-italic text-lg",
      body: "font-sans font-normal not-italic text-base",
      bodySm: "font-sans font-normal not-italic text-sm",
      caption: "font-sans font-normal not-italic text-xs",
    },
  },
  defaultVariants: {
    preset: "body",
  },
});

export type TypographyVariantProps = VariantProps<typeof typographyCva>;
